"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var StickyHeader = /** @class */ (function () {
    function StickyHeader(selector) {
        var _this = this;
        this.scrollOffset = 300;
        // Check the scroll position to set the is-sticky class to header
        this.checkScrollPosition = function () {
            if (window.scrollY > _this.scrollOffset) {
                _this.header.classList.add(constants_1.CLASS_STICKY);
            }
            else {
                _this.header.classList.remove(constants_1.CLASS_STICKY);
            }
        };
        this.header = document.querySelector(selector);
        window.addEventListener('scroll', this.checkScrollPosition);
    }
    return StickyHeader;
}());
exports.default = StickyHeader;
